import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ColorSwatch from 'components/ColorSwatch';
import Theme from 'styles/theme';
import CustomPropTypes from 'utils/PropTypes';

const ColorSwatchButton = class extends Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    colors: CustomPropTypes.colorSwatch, // eslint-disable-line react/require-default-props
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    className: PropTypes.string,
    isSelected: PropTypes.bool,
    diameter: PropTypes.number,
    angle: PropTypes.number,
    ariaLabel: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onClick: () => {},
    imageUrl: '',
    className: '',
    isDisabled: false,
    isSelected: false,
    diameter: 30,
    angle: 135,
  };

  get size() {
    return this.props.diameter > Theme.get('touch-target-size')
      ? this.props.diameter
      : Theme.get('touch-target-size');
  }

  render() {
    const {
      ariaLabel,
      className,
      isDisabled,
      isSelected,
      onClick,
      imageUrl,
      colors,
      diameter,
      angle,
    } = this.props;

    const ColorSwatchButtonClass = classNames('ColorSwatchButton', className, {
      'ColorSwatchButton--disabled': isDisabled,
      'ColorSwatchButton--active': isSelected,
    });

    const ariaPressed = isSelected ? 'true' : 'false';

    return (
      <button
        className={ColorSwatchButtonClass}
        onClick={onClick}
        disabled={isDisabled}
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
        type="button"
      >
        <ColorSwatch colors={colors} imageUrl={imageUrl} diameter={diameter} angle={angle} />
        <style jsx>
          {`
            .ColorSwatchButton {
              border: none;
              padding: 0;
              display: inline-block;
              cursor: pointer;
              text-align: center;
              background-color: transparent;
              width: ${this.size}px;
              height: ${this.size}px;
              outline: none;
            }

            .ColorSwatchButton--disabled {
              cursor: initial;
              opacity: 0.25;
            }
          `}
        </style>
        <style jsx global>
          {`
            .ColorSwatch::after {
              content: '';
              position: absolute;
              top: 0px;
              right: 0px;
              bottom: 0px;
              left: 0px;
              border-radius: 50%;
              transition: ${Theme.get('transition-duration') / 2}ms all
                ${Theme.get('transition-timing-ease-out-quad')};
              border: 2px solid transparent;
            }

            .ColorSwatchButton:hover .ColorSwatch::after,
            .ColorSwatchButton:focus .ColorSwatch::after,
            .ColorSwatchButton--active .ColorSwatch::after {
              top: -4px;
              right: -4px;
              bottom: -4px;
              left: -4px;
            }

            .ColorSwatchButton:hover .ColorSwatch::after,
            .ColorSwatchButton:focus .ColorSwatch::after {
              border-color: ${Theme.get('colors-grey')};
            }

            .ColorSwatchButton--active:hover .ColorSwatch::after,
            .ColorSwatchButton--active:focus .ColorSwatch::after,
            .ColorSwatchButton--active .ColorSwatch::after {
              border-color: ${Theme.get('colors-black-60')};
              transition-duration: ${Theme.get('transition-duration-ms')};
            }

            .ColorSwatchButton.focused .ColorSwatch::after {
              border-color: ${Theme.get('colors-black')};
            }
          `}
        </style>
      </button>
    );
  }
};

export default ColorSwatchButton;
